import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
const API = "https://api.ctexpresskh.com/api";

export default function Slideshows() {
  const [slides, setSlides] = useState([]);
  const [form, setForm] = useState({ title:"", image_url:"", link_url:"", sort_order:0, is_active:true });
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [uploading, setUploading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => { load(); }, []);

  const load = async () => {
    const res = await fetch(API + "/settings/slideshows", { headers: { Authorization: "Bearer " + token } });
    const data = await res.json();
    if (data.success) setSlides(data.data || []);
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    try {
      const res = await fetch(API + "/settings/upload-slide", {
        method: "POST",
        headers: { Authorization: "Bearer " + token },
        body: formData
      });
      const data = await res.json();
      if (data.success) { setForm(f => ({ ...f, image_url: data.url })); toast.success("Image uploaded!"); }
      else toast.error(data.message);
    } catch { toast.error("Upload failed"); }
    setUploading(false);
  };

  const save = async () => {
    const method = editing ? "PUT" : "POST";
    const url = editing ? API + "/settings/slideshows/" + editing : API + "/settings/slideshows";
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      body: JSON.stringify(form)
    });
    const data = await res.json();
    if (data.success) { toast.success("Saved!"); load(); setShowForm(false); setEditing(null); setForm({ title:"", image_url:"", link_url:"", sort_order:0, is_active:true }); }
    else toast.error(data.message);
  };

  const del = async (id) => {
    if (!window.confirm("Delete this slide?")) return;
    await fetch(API + "/settings/slideshows/" + id, { method:"DELETE", headers: { Authorization: "Bearer " + token } });
    toast.success("Deleted!"); load();
  };

  const edit = (s) => { setForm(s); setEditing(s.id); setShowForm(true); };

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <div>
          <h2 style={{ margin:0, fontSize:22, fontWeight:700 }}>🖼️ Slideshow Manager</h2>
          <p style={{ margin:"4px 0 0", color:"#6b7280", fontSize:13 }}>Manage home screen slideshow images</p>
        </div>
        <button onClick={() => { setShowForm(true); setEditing(null); setForm({ title:"", image_url:"", link_url:"", sort_order:0, is_active:true }); }}
          style={{ backgroundColor:"#dc2626", color:"#fff", border:"none", borderRadius:8, padding:"10px 20px", fontWeight:700, cursor:"pointer" }}>
          + Add Slide
        </button>
      </div>

      {showForm && (
        <div style={{ backgroundColor:"#fff", borderRadius:12, border:"1px solid #e5e7eb", padding:24, marginBottom:24 }}>
          <h3 style={{ margin:"0 0 16px", fontSize:16, fontWeight:700 }}>{editing ? "Edit Slide" : "Add New Slide"}</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Title</label>
              <input value={form.title} onChange={e => setForm(f => ({...f, title:e.target.value}))}
                placeholder="Slide title" style={{ width:"100%", padding:"8px 12px", border:"1px solid #d1d5db", borderRadius:8, fontSize:14, boxSizing:"border-box" }} />
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Sort Order</label>
              <input type="number" value={form.sort_order} onChange={e => setForm(f => ({...f, sort_order:parseInt(e.target.value)||0}))}
                style={{ width:"100%", padding:"8px 12px", border:"1px solid #d1d5db", borderRadius:8, fontSize:14, boxSizing:"border-box" }} />
            </div>
            <div style={{ gridColumn:"1/-1" }}>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Image</label>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <input value={form.image_url} onChange={e => setForm(f => ({...f, image_url:e.target.value}))}
                  placeholder="Image URL or upload below" style={{ flex:1, padding:"8px 12px", border:"1px solid #d1d5db", borderRadius:8, fontSize:14 }} />
                <label style={{ backgroundColor:"#3b82f6", color:"#fff", padding:"8px 16px", borderRadius:8, cursor:"pointer", fontWeight:600, fontSize:13, whiteSpace:"nowrap" }}>
                  {uploading ? "Uploading..." : "📤 Upload"}
                  <input type="file" accept="image/*" onChange={handleUpload} style={{ display:"none" }} />
                </label>
              </div>
              {form.image_url && <img src={form.image_url} alt="preview" style={{ marginTop:8, height:80, borderRadius:8, objectFit:"cover" }} onError={e => e.target.style.display='none'} />}
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:"#374151", display:"block", marginBottom:4 }}>Link URL (optional)</label>
              <input value={form.link_url} onChange={e => setForm(f => ({...f, link_url:e.target.value}))}
                placeholder="https://..." style={{ width:"100%", padding:"8px 12px", border:"1px solid #d1d5db", borderRadius:8, fontSize:14, boxSizing:"border-box" }} />
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:8, paddingTop:20 }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm(f => ({...f, is_active:e.target.checked}))} id="active" />
              <label htmlFor="active" style={{ fontSize:14, fontWeight:600 }}>Active</label>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, marginTop:16 }}>
            <button onClick={save} style={{ backgroundColor:"#dc2626", color:"#fff", border:"none", borderRadius:8, padding:"10px 24px", fontWeight:700, cursor:"pointer" }}>
              💾 Save
            </button>
            <button onClick={() => { setShowForm(false); setEditing(null); }}
              style={{ backgroundColor:"#f3f4f6", color:"#374151", border:"none", borderRadius:8, padding:"10px 24px", fontWeight:700, cursor:"pointer" }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:16 }}>
        {slides.map(s => (
          <div key={s.id} style={{ backgroundColor:"#fff", borderRadius:12, border:"1px solid #e5e7eb", overflow:"hidden" }}>
            {s.image_url && <img src={s.image_url} alt={s.title} style={{ width:"100%", height:140, objectFit:"cover" }} onError={e => e.target.style.display='none'} />}
            <div style={{ padding:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <span style={{ fontWeight:700, fontSize:14 }}>{s.title || "Untitled"}</span>
                <span style={{ backgroundColor: s.is_active ? "#dcfce7":"#fee2e2", color: s.is_active ? "#16a34a":"#dc2626", fontSize:11, fontWeight:700, padding:"2px 8px", borderRadius:20 }}>
                  {s.is_active ? "Active" : "Inactive"}
                </span>
              </div>
              <div style={{ fontSize:12, color:"#6b7280", marginTop:4 }}>Order: {s.sort_order}</div>
              <div style={{ display:"flex", gap:8, marginTop:12 }}>
                <button onClick={() => edit(s)} style={{ flex:1, padding:"7px", backgroundColor:"#f3f4f6", border:"none", borderRadius:8, cursor:"pointer", fontWeight:600, fontSize:13 }}>✏️ Edit</button>
                <button onClick={() => del(s.id)} style={{ flex:1, padding:"7px", backgroundColor:"#fee2e2", color:"#dc2626", border:"none", borderRadius:8, cursor:"pointer", fontWeight:600, fontSize:13 }}>🗑️ Delete</button>
              </div>
            </div>
          </div>
        ))}
        {slides.length === 0 && <div style={{ gridColumn:"1/-1", textAlign:"center", padding:40, color:"#6b7280" }}>No slides yet. Add your first slide!</div>}
      </div>
    </div>
  );
}
